import {
  RadioGroup as MuiRadioGroup,
  RadioGroupProps as MuiRadioGroupProps,
  FormControl,
  FormLabel,
  Input,
  Radio,
} from "@mui/material";
import { FormControlLabel, SxProps, Theme, useTheme } from "@mui/material";
import { RichTextReader, Stack } from "@compass/core";
import { FormQuestionWriteInTypes } from "pages/cobro/surveys/SurveyPage/Questions/SurveyQuestionEnum";
import CurrencyInput from "react-currency-input-field";

export type RadioGroupProps = MuiRadioGroupProps & {
  label?: string;
  value: any;
  onChange: (option: RadioOption | undefined) => any;
  onOtherChange: (value: any, otherValue: string) => any;
  options: RadioOption[];
  isDisabled: boolean;
};

export type RadioOption = {
  label: string;
  value: string | number | boolean;
  valueType: "EntityId" | "AnswerId";
  isOther: boolean;
  isOtherValue?: string | null;
  otherTypeId?: FormQuestionWriteInTypes | null;
  isEndAnswer?: boolean | null;
  endAnswerText?: string | null;
};

export const RadioGroup = ({ label, value, options, isDisabled, onChange, onOtherChange }: RadioGroupProps) => {
  const theme = useTheme();
  const rootStyle: SxProps<Theme> = {
    fontWeight: theme.typography.fontWeightBold,
  };

  const currencyStyle = {
    color: "rgba(0, 0, 0, 0.87)",
    padding: "16.5px 14px",
    borderRadius: "5px",
    borderWidth: "1.25px",
    borderStyle: "solid",
    borderColor: "rgba(0, 0, 0, 0.20)" 
  };

  const handleClick = (event: any) => {
    var selectedValue = event.target.value;
    const newValue = value === selectedValue ? null : selectedValue;
    const mappedOption = options.find((o) => o.value == newValue);
    onChange(mappedOption);
  };

  const handleOtherChange = (option: RadioOption, otherValue: string) => {
    option.isOtherValue = otherValue;
    onOtherChange(option.value, option.isOtherValue);
  };

  return (
    <FormControl>
      {label && <FormLabel id={label}>{label}</FormLabel>}
      <MuiRadioGroup aria-labelledby="radio-buttons-group" name="controlled-radio-buttons-group" value={value}>
        {options.map((o, index) => (
          <Stack key={o.value.toString()} direction="row" py={1}>
            <FormControlLabel
              value={o.value}
              control={<Radio onClick={handleClick} disabled={isDisabled} />}
              label={<RichTextReader html={o.label} />}
            />
            {o.isOther && value == o.value && (
              <>
                {o.otherTypeId != FormQuestionWriteInTypes.Currency && (
                  <Input
                    style={{ marginTop: 0 }}
                    placeholder=""
                    disabled={isDisabled}
                    value={o.isOtherValue}
                    onChange={(e) => {
                      handleOtherChange(o, e.target.value);
                    }}
                    type={
                      o.otherTypeId == FormQuestionWriteInTypes.Number
                        ? "number"
                        : o.otherTypeId == FormQuestionWriteInTypes.Date
                        ? "date"
                        : "text"
                    }
                  />
                )}
                {o.otherTypeId == FormQuestionWriteInTypes.Currency && (
                  <CurrencyInput
                    style={currencyStyle}
                    id={label}
                    disabled={isDisabled}
                    prefix="$"
                    defaultValue={undefined}
                    value={o.isOtherValue || undefined}
                    decimalsLimit={2}
                    onValueChange={(value, name, values) => {
                      handleOtherChange(o, value || "");
                    }}
                  />
                )}
              </>
            )}
          </Stack>
        ))}
      </MuiRadioGroup>
    </FormControl>
  );
};
